<template>
  <generic-modal :title="$t('process')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.name"
                :placeholder="$t('process name')"
              />
            </div>
          </div>
        </div>
        <div class="column"></div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
        v-bind:class="{ 'is-loading': loading }"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "EmitterModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      loading: false,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();
      get("/ngine/composer/process", { uuid: uuid })
        .then((response) => {
          v.meta = response;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          error_message(error);
        });
    },
    save() {
      let v = this;
      v.$root.loader(true);
      if (v.meta.uuid) {
        post("/ngine/composer/process", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.loading = false;
            v.$root.loader(false);
          });
      } else {
        put("/ngine/composer/process", v.meta)
          .then((process_uuid) => {
            v.$router.push({ path: `/ngine/composer/process/${process_uuid}` });
            // v.$emit("success");
            // v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.loading = false;
            v.$root.loader(false);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
